import React from "react";
import {Route, Redirect, Switch} from "react-router-dom";
import URLS from "../../config/navigation";
import SetupProfile from "../../components/Profile/SetupProfile";
import GenerateUserLink from "../../components/Profile/GenerateUserLink";
import ConnectBankAccountPreview from "../../components/Profile/ConnectBankAccountPreview";
import FinishAccountSettings from "../../components/Profile/FinishAccountSettings";
import PaymentStatusSuccess from "../../components/Profile/PaymentStatusSuccess";
import AccountConnect from "../../components/Profile/AccountConnect";
import PreProtectedRoute from "../../components/preProtectedROute";

const Public = () => {

    return (
        <div className={"publicContainer"}>
            <div className={"publicWrapper publicsections"}>
                <Switch>
                    <PreProtectedRoute path={URLS.PUBLIC.SETUP} component={SetupProfile}/>
                    <PreProtectedRoute path={URLS.PUBLIC.LINK} component={GenerateUserLink}/>
                    <PreProtectedRoute path={URLS.PUBLIC.PREVIEW_CONNECT_BANK_ACC} component={ConnectBankAccountPreview}/>
                    <PreProtectedRoute path={URLS.PUBLIC.FINISH_SETTINGS_ACC} component={FinishAccountSettings}/>
                    <Route path={URLS.PUBLIC.PAYMENT_SUCCEEDED} component={PaymentStatusSuccess}/>
                    <PreProtectedRoute path={URLS.PUBLIC.STRIPE_CONNECT} component={AccountConnect}/>
                    <Route component={() => <Redirect to={URLS.PROFILE.ROOT}/>}/>
                </Switch>
            </div>
        </div>
    );
};

export default Public;
